import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';
import { useError } from '../../hooks/useError';
import ErrorMessage from '../ErrorMessage';

export const Layout = ({ loggedIn, userName, children }) => {
    const { error } = useError();

    useEffect(() => {
        if (error) {
            // Scroll the user to the error at the top of the page.
            window.scrollTo(0, 0);
        }
    });

    return (
        <Styled.LayoutWrapper>
            {loggedIn && (
                <Styled.WelcomeMessage>
                    Welcome, <Styled.Name>{userName}</Styled.Name>
                </Styled.WelcomeMessage>
            )}
            <ErrorMessage message={error} />
            {children}
            <Styled.Footer>
                <div>
                    © Copyright ITV Consumer Limited {new Date().getFullYear()}.
                    The ITV Racing 7 and ITV Racing logos are trade marks of ITV
                    Rights Limited.
                </div>
            </Styled.Footer>
        </Styled.LayoutWrapper>
    );
};

Layout.defaultProps = {
    userName: null,
    children: null
};

Layout.propTypes = {
    loggedIn: PropTypes.bool.isRequired,
    userName: PropTypes.string,
    children: PropTypes.node
};

export default Layout;
